import styled from 'styled-components'

import { useSvgHref } from '../../svgHrefContext'

import * as icon from '../Icon'

const SYMBOL_ID = 'icon-play-def'

FullPlay.filename = SYMBOL_ID
export function FullPlay(props: icon.SpecificIconProps): React.ReactElement {
    return (
        <icon.Icon {...props} name="play">
            <defs>
                <g id={SYMBOL_ID}>
                    <path d="M1 20.35c.05 2.05 2.35 3.29 4.36 2.31l16.16-8.39A2.6 2.6 0 0023 12c0-.99-.6-1.83-1.48-2.28L5.36 1.34C3.34.37 1.06 1.6 1 3.64v16.7z" />
                </g>
            </defs>
            <use href={`#${SYMBOL_ID}`} />
        </icon.Icon>
    )
}

export const Play = styled(function Play(
    props: icon.SpecificIconProps
): React.ReactElement {
    const href = useSvgHref(SYMBOL_ID)
    return (
        <icon.Icon {...props} name="play">
            <use href={href} />
        </icon.Icon>
    )
})``
